'use client';
import { isCustomSkin, normalizeSkinId } from 'contexts/SkinProvider';
import React, { useEffect, useState } from 'react';

const SkinStylesheet: React.FC = () => {
  const [skin, setSkin] = useState<string | null>(null);

  useEffect(() => {
    const cookies = document.cookie.split(';');
    const skinCookie = cookies.find((cookie) =>
      cookie.trim().startsWith('theme='),
    );
    const storedSkin = skinCookie ? skinCookie.split('=')[1].trim() : 'mintrh';
    setSkin(normalizeSkinId(storedSkin));
  }, []);

  if (!skin) return null; // Attendre que le skin soit récupéré

  if (isCustomSkin(skin)) return null;

  return (
    <>
      <link id="skin" href={`/skin/skin.${skin}.css`} rel="stylesheet" />
      <link id="skin" href={`/auth-skin/skin.${skin}.css`} rel="stylesheet" />
    </>
  );
};

export default SkinStylesheet;
